/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

export const recordAttributionV2ResponseDataSchema = z.object({
  recorded: z.boolean(),
});

export type IRecordAttributionV2ResponseData = z.infer<
  typeof recordAttributionV2ResponseDataSchema
>;

export const recordAttributionV2ResponseSchema = createApiResponseSchema(
  recordAttributionV2ResponseDataSchema,
) as z.ZodSchema<IAPI<IRecordAttributionV2ResponseData>>;

export type IRecordAttributionV2Response = IAPI<IRecordAttributionV2ResponseData>;
